var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.days.length > 0)?_c('ClosestHoliday',{attrs:{"days":_vm.days,"regions":_vm.regions,"region":_vm.chosenRegion},on:{"get:events":_vm.getNewRegion}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }